import { Injectable } from "@angular/core";
import { historicoRequest, historicoResponse, LoginResponse, Dados, boletoResponse, boletoRequest } from "./boleto";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { mergeMap } from 'rxjs/operators';
import { EnvService } from "../env/env.service";

@Injectable({
  providedIn: 'root'
})
export class BoletoService {
  private _requestHistorico: historicoRequest;
  private _requestBoleto: boletoRequest;
  private uri: string = "";
  private urlApiMutualCertification: string = "";
  valorhtml: string = "";

  constructor(private httpClient: HttpClient, private env: EnvService) {
    this._requestHistorico = new historicoRequest();
    this._requestBoleto = new boletoRequest();
    this.urlApiMutualCertification = env.apiMutualCertification;
  }
  ConsultarHistorico(tokenGoogle: string, beneficiario: string, pagador: string, nossonumero: number) {
    this._requestHistorico.CPFCNPJBeneficiario = beneficiario.trim().replace(".", "").replace("-", "").replace(".", "").replace("/", "");
    this._requestHistorico.CPFCNPJSacado = pagador.trim().replace(".", "").replace("-", "").replace(".", "").replace("/", "");
    this._requestHistorico.NossoNumero = nossonumero;
    return this.PostLogarApiMutualCertification(tokenGoogle).pipe(
      mergeMap(
        resp => {
          return this.GetHistorico(resp.token);
        }
      )
    );
  }
  ConsultarBoleto(tokenGoogle: string, cedente: number, nossonumero: number, tipoBoleto: number) {
    this._requestBoleto.cedente = cedente;
    this._requestBoleto.nossoNumero = nossonumero;
    this._requestBoleto.tipoBoleto = tipoBoleto;
    return this.PostLogarApiMutualCertification(tokenGoogle).pipe(
      mergeMap(
        resp => {
          return this.GetBoleto(resp.token);
        }
      )
    );
  }
  ConsultarBoletoEmUmPasso(tokenGoogle: string, beneficiario: string, pagador: string, nossonumero: number) {
    this._requestHistorico.CPFCNPJBeneficiario = beneficiario.trim().replace(".", "").replace("-", "").replace(".", "").replace("/", "");
    this._requestHistorico.CPFCNPJSacado = pagador.trim().replace(".", "").replace("-", "").replace(".", "").replace("/", "");
    this._requestHistorico.NossoNumero = nossonumero;
    return this.PostLogarApiMutualCertification(tokenGoogle).pipe(
      mergeMap(
        resp => {
          return this.GetBoletoEmUmPasso(resp.token);
        }
      )
    );
  }
  PostLogarApiMutualCertification(tokenGoogle: string): Observable<LoginResponse> {
    this.uri = "APIMutualCertification/v1/login";
    const httpOptions = {
      headers: new HttpHeaders({
        'X-Requested-With': 'XMLHttpRequest'
      })
    };
    let body = {
      token: tokenGoogle
    };
    return this.httpClient.post<LoginResponse>(this.urlApiMutualCertification + this.uri, body, httpOptions);
  }
  GetHistorico(token: string): Observable<historicoResponse[]> {
    this.uri = "APIMutualCertification/v1/historico";
    const httpOptions = {
      headers: new HttpHeaders()
        .set("X-Requested-With", "XMLHttpRequest")
        .set("Authorization", token)
      ,
      params: new HttpParams()
        //.set('Cedente', ''/*String(this._requestHistorico.Cedente)*/)
        //.set('Carteira', String(this._requestHistorico.Carteira))
        //.set('SeuNumero', '')
        .set('NossoNumero', String(this._requestHistorico.NossoNumero))
        .set('CPFCNPJSacado', this._requestHistorico.CPFCNPJSacado)
        .set('CPFCNPJBeneficiario', this._requestHistorico.CPFCNPJBeneficiario)
    }
    return this.httpClient.get<historicoResponse[]>(this.urlApiMutualCertification + this.uri, httpOptions);
  }
  GetBoleto(token: string): Observable<boletoResponse[]> {
    this.uri = "APIMutualCertification/v1/boleto";
    const httpOptions = {
      headers: new HttpHeaders()
        .set("X-Requested-With", "XMLHttpRequest")
        .set("Authorization", token),
      params: new HttpParams()
        .set('Cedente', String(this._requestBoleto.cedente))
        .set('NossoNumero', String(this._requestBoleto.nossoNumero))
        .set('TipoBoleto', String(this._requestBoleto.tipoBoleto))
    }
    const body = [];
    return this.httpClient.get<boletoResponse[]>(this.urlApiMutualCertification + this.uri, httpOptions);
  }
  GetBoletoEmUmPasso(token: string): Observable<boletoResponse[]> {
    this.uri = "apiapimutualcertification/v2/boletoemumpasso";
    const httpOptions = {
      headers: new HttpHeaders()
        .set("X-Requested-With", "XMLHttpRequest")
        .set("Authorization", token),
      params: new HttpParams()
      .set('NossoNumero', String(this._requestHistorico.NossoNumero))
      .set('CPFCNPJSacado', this._requestHistorico.CPFCNPJSacado)
      .set('CPFCNPJBeneficiario', this._requestHistorico.CPFCNPJBeneficiario)
    }
    const body = [];
    return this.httpClient.get<boletoResponse[]>(this.urlApiMutualCertification + this.uri, httpOptions);
  }
}
